import { render, staticRenderFns } from "./PassedAppointments.vue?vue&type=template&id=16f22f04&scoped=true"
import script from "./PassedAppointments.vue?vue&type=script&lang=js"
export * from "./PassedAppointments.vue?vue&type=script&lang=js"
import style0 from "./PassedAppointments.vue?vue&type=style&index=0&id=16f22f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f22f04",
  null
  
)

export default component.exports